/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 13:30:22
 * @LastEditTime: 2022-03-22 10:10:19
 * @LastEditors: Yandong Hu
 * @Description:
 */

import ajaxService from "./ajax/ajax.service";
import apis from "./ajax/apis";
import { DEFAULT_EXPORT_NAME } from "./config.service";
import cookieService from "./cookie.service";
import {
  messageFloatError,
  messageFloatSuccess,
} from "./message/message-float.service";
let mblock: any;

/**
 * 定时检查Mblock对象是否被注入到window
 *
 * @return {*}
 */
function checkMblockObject() {
  return new Promise((resolve) => {
    const check = setInterval((_) => {
      if (typeof MBlock === "function") {
        clearInterval(check);
        resolve(true);
      }
    }, 100);
  });
}
/**
 * 初始化IDE
 *
 * @return {*}
 */
async function initIDE() {
  await checkMblockObject();
  mblock = new MBlock({
    showHeader: false,
    // 是否开启加载项目的 loading 页
    enableProjectLoadingPage: true,
    // 角色资源配置，以数组的形式配置多个资源环境
    spriteAssetConfig: [
      // 如：额外添加一个自己的角色配置
      {
        basepath(asset: any) {
          console.log(asset);
          if (asset.md5) {
            return "static/resource/scratch/" + asset.md5;
          } else if (asset.baseLayerMD5) {
            return "static/resource/scratch/" + asset.baseLayerMD5;
          } else if (asset.assetId && asset.dataFormat) {
            return (
              "static/resource/scratch/" +
              asset.assetId +
              "." +
              asset.dataFormat
            );
          }
        },
        sprites: "static/sprites/customize/sprites.json",
        autoCreateWebStore: true,
      },
      MBlock.MakeblockAssets,
      MBlock.ScratchAssets,
    ],
    defaultExts: ["codey"],
    // 是否打开代码编辑器功能
    openCodeEditor: false,
    // 是否打开代码对照功能
    openCodeMirror: false,
    // 设置默认语言，如果没有设置会根据浏览器环境语言，如果当前语言不支持则会是英文环境
    // 目前只支持设置 zh 和 en
    defaultLang: "zh",
    blocklyOptions: {
      zoom: {
        startScale: 0.675,
      },
    },
    downloadDriverBtn: {
      text: "下载驱动",
      handler: () => {
        alert("下载驱动");
      },
    },
    primaryColor: "#04bbff",
  });
  return mblock;
}
/**
 * 渲染ide到HTML节点
 *
 * @param {string} htmlElementSelecterStr
 */
function renderIDE(htmlElementSelecterStr: string) {
  mblock.inject(htmlElementSelecterStr);
}

/**
 * 设置登录状态
 *
 * @param {boolean} state
 */
function setLogin(state: boolean) {
  mblock.account.setLogin(state);
}

/**
 * 新建项目
 *
 */
function doNew() {
  mblock.project.reset();
}

/**
 * 导入项目
 *
 */
function doImport() {
  mblock.project.import(() => {
    // messageFloatSuccess("导入成功！");
  });
}

/**
 * 导出项目
 *
 * @param {string} [exportName=DEFAULT_EXPORT_NAME] 导出项目默认名称
 */
function doExport(exportName: string = DEFAULT_EXPORT_NAME) {
  mblock.project.export({
    name: exportName,
  });
}

/**
 * 获取封面图片
 *
 * @return {*} base64
 */
function getCover() {
  var b64 = mblock.project.getCover();
  return b64;
}

/**
 * 通过url加载工程
 *
 * @param {string} url
 */
function renderProject(url: string) {
  mblock.project.renderFromUrl(
    url,
    () => {
      messageFloatSuccess("加载成功！");
    },
    (_err: any) => {
      messageFloatSuccess("加载失败！");
    }
  );
}

/**
 * 项目加载进度
 *
 * @param {*} cb 0-1
 */
function onLoadingProject(cb: any) {
  mblock.project.onLoadingProject((complete: number, total: number) => {
    if (complete / total <= 1) {
      const num = (complete / total).toFixed(2);
      cb(parseFloat(num));
    } else {
      cb(1);
    }
  });
}
/**
 * 项目加载，返回项目名称
 *
 * @param {*} cb
 */
function onLoadedProject(cb: any) {
  console.log(mblock.project);
  mblock.project.onLoadedProject((args: any) => {
    if (args && args.projectName) {
      cb(args.projectName);
    } else {
      cb(undefined);
    }
  });
}
/**
 * ajax获取token
 *
 * @return {*}
 */
async function getToken() {
  const data: any = await ajaxService.get(apis.getAccessToken);
  if (data && data.code === "0") {
    return data.data;
  }
  throw new Error("无法获取token");
}
/**
 * 判断token是否存在和有效，并获取最新token保存到cookie
 *
 */
function getAccesstoken() {
  if (!cookieService.getCookie("accesstoken")) {
    getToken()
      .then((token) => {
        if (token) {
          cookieService.setCookie("accesstoken", token);
        } else {
          messageFloatError("无效的token");
        }
      })
      .catch((e) => {
        messageFloatError("无法获取验证信息");
      });
  }
}
const mblockService = {
  doNew,
  doImport,
  doExport,
  getCover,
  renderProject,
  initIDE,
  renderIDE,
  setLogin,
  checkMblockObject,
  onLoadingProject,
  onLoadedProject,
  getAccesstoken,
};

export default mblockService;
